import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import useAsync from 'react-use/esm/useAsync';
import { buildDocTree } from './buildDocTree';

/**
 * Kinds the tree renders. Group is included because the githubOrg team
 * transformer stamps `backstage.io/techdocs-ref` onto team entities (see
 * `docs/plugins/Hone/techdocs.md`); User/Location/Template never carry docs.
 */
export const TREE_KINDS = [
  'domain',
  'system',
  'component',
  'repository',
  'api',
  'resource',
  'group',
];

/** The full catalog, nested Domain -> System -> entity, for the docs tree. */
export const useEntityDocTree = () => {
  const catalogApi = useApi(catalogApiRef);

  return useAsync(async () => {
    const { items } = await catalogApi.getEntities({
      filter: TREE_KINDS.map(kind => ({ kind })),
      fields: [
        'kind',
        'metadata.name',
        'metadata.namespace',
        'metadata.title',
        'metadata.tags',
        'metadata.annotations',
        'relations',
        'spec.type',
        'spec.lifecycle',
      ],
    });

    return buildDocTree(items);
  }, [catalogApi]);
};
